import { render, staticRenderFns } from "./JdsNavigatorFullPageLayout.vue?vue&type=template&id=a64c52c4&scoped=true&"
import script from "./JdsNavigatorFullPageLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorFullPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigatorFullPageLayout.vue?vue&type=style&index=0&id=a64c52c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c52c4",
  null
  
)

export default component.exports